export const SNAP_APP_STEP_ID = 'snap';
